module.exports = [
  {
    label: {
      de: 'Belgien',
      en: 'Belgium'
    },
    value: 'BE'
  },
  {
    label: {
      de: 'Bulgarien',
      en: 'Bulgaria'
    },
    value: 'BG'
  },
  {
    label: {
      de: 'Dänemark',
      en: 'Denmark'
    },
    value: 'DK'
  },
  {
    label: {
      de: 'Deutschland',
      en: 'Germany'
    },
    value: 'DE'
  },
  {
    label: {
      de: 'Estland',
      en: 'Estonia'
    },
    value: 'EST'
  },
  {
    label: {
      de: 'Finnland',
      en: 'Finland'
    },
    value: 'FIN'
  },
  {
    label: {
      de: 'Frankreich',
      en: 'France'
    },
    value: 'FR'
  },
  {
    label: {
      de: 'Griechenland',
      en: 'Greece'
    },
    value: 'GR'
  },
  {
    label: {
      de: 'Island',
      en: 'Iceland'
    },
    value: 'IS'
  },
  {
    label: {
      de: 'Irland',
      en: 'Ireland'
    },
    value: 'IE'
  },
  {
    label: {
      de: 'Israel',
      en: 'Israel'
    },
    value: 'IS'
  },
  {
    label: {
      de: 'Italien',
      en: 'Italy'
    },
    value: 'IT'
  },
  {
    label: {
      de: 'Japan',
      en: 'Japan'
    },
    value: 'JP'
  },
  {
    label: {
      de: 'Kroatien',
      en: 'Croatia'
    },
    value: 'HR'
  },
  {
    label: {
      de: 'Lettland',
      en: 'Latvia'
    },
    value: 'LV'
  },
  {
    label: {
      de: 'Lichtenstein',
      en: 'Lichtenstein'
    },
    value: 'LI'
  },
  {
    label: {
      de: 'Litauen',
      en: 'Lithuania'
    },
    value: 'LT'
  },
  {
    label: {
      de: 'Luxemburg',
      en: 'Luxembourg'
    },
    value: 'LU'
  },
  {
    label: {
      de: 'Malta',
      en: 'Malta'
    },
    value: 'MT'
  },
  {
    label: {
      de: 'Niederlande',
      en: 'Netherlands'
    },
    value: 'NL'
  },
  {
    label: {
      de: 'Norwegen',
      en: 'Norway'
    },
    value: 'NO'
  },
  {
    label: {
      de: 'Österreich',
      en: 'Austria'
    },
    value: 'AT'
  },
  {
    label: {
      de: 'Polen',
      en: 'Poland'
    },
    value: 'PO'
  },
  {
    label: {
      de: 'Portugal',
      en: 'Portugal'
    },
    value: 'PT'
  },
  {
    label: {
      de: 'Rumänien',
      en: 'Romania'
    },
    value: 'RO'
  },
  {
    label: {
      de: 'Schweden',
      en: 'Sweden'
    },
    value: 'SE'
  },
  {
    label: {
      de: 'Schweiz',
      en: 'Switzerland'
    },
    value: 'CH'
  },
  {
    label: {
      de: 'Slowakei',
      en: 'Slovakia'
    },
    value: 'SK'
  },
  {
    label: {
      de: 'Slowenien',
      en: 'Slovenia'
    },
    value: 'SI'
  },
  {
    label: {
      de: 'Spanien',
      en: 'Espania'
    },
    value: 'ES'
  },
  {
    label: {
      de: 'Tschechien',
      en: 'Czech Republic'
    },
    value: 'CZ'
  },
  {
    label: {
      de: 'Türkei',
      en: 'Turky'
    },
    value: 'TR'
  },
  {
    label: {
      de: 'Ungarn',
      en: 'Hungary'
    },
    value: 'HU'
  },
  {
    label: {
      de: 'Vereinigtes Königreich',
      en: 'United Kingdom'
    },
    value: 'GB'
  },
  {
    label: {
      de: 'Zypern',
      en: 'Cyprus'
    },
    value: 'CYP'
  },
];
